<template>
<div class="card float-e-margins">
  <div class="card-title">
      <h1>Gevonden resultaten voor: <u><strong>{{ $route.params.term }}<strong><u></h1>
  </div>
  <div class="card-content no-padding">
    <div class="row" v-if="!loaded">
      <div class="col-md-2 col-md-offset-5">
        <img v-else class="img-responsive" src="../assets/img/ajax_loader.gif" style="max-height:200px;">
      </div>
    </div>
    <div v-else class="row category-credit" style="margin-top:20px">
      <div v-for="product in products" class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
        <product-card :product="product" ></product-card>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import store from '../store'
import ProductCard from '../components/Common/ProductCard'

export default {
  route: {
    canReuse: false
  },
  components: {
    ProductCard
  },
  data () {
    return {
      store: store,
      products: {},
      loaded: false
    }
  },
  created () {
  },
  ready () {
    $.ajax({
      type: 'GET',
      url: store.root + 'api/products/search/' + this.$route.params.term,
      dataType: 'json',
      xhrFields: {
        withCredentials: true
      },
      success: function (response) {
        this.loaded = true
        this.products = response
      }.bind(this)
    })
  }
}
</script>


// WEBPACK FOOTER //
// Search.vue?51ae939e